// Modules
import React from "react";

const DishwasherIcon = (props) => {
	return (
		<svg
			height="1em"
			viewBox="0 0 512 512"
			width="1em"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>

			<g>
				<g>
					<path d="M460.8,0H51.2c-4.71,0-8.533,3.823-8.533,8.533v494.933c0,4.719,3.823,8.533,8.533,8.533h409.6
			c4.719,0,8.533-3.814,8.533-8.533V8.533C469.333,3.823,465.519,0,460.8,0z M452.267,494.933H59.733V17.067h392.533V494.933z"/>
				</g>
			</g>
			<g>
				<g>
					<rect x="51.2" y="85.333" width="409.6" height="17.067" />
				</g>
			</g>
			<g>
				<g>
					<path d="M409.6,119.467H102.4c-14.114,0-25.6,11.486-25.6,25.6v307.2c0,14.114,11.486,25.6,25.6,25.6h307.2
			c14.114,0,25.6-11.486,25.6-25.6v-307.2C435.2,130.953,423.714,119.467,409.6,119.467z M418.133,452.267
			c0,4.71-3.823,8.533-8.533,8.533H102.4c-4.702,0-8.533-3.823-8.533-8.533v-307.2c0-4.702,3.831-8.533,8.533-8.533h307.2
			c4.71,0,8.533,3.831,8.533,8.533V452.267z"/>
				</g>
			</g>
			<g>
				<g>
					<rect x="85.333" y="256" width="341.333" height="17.067" />
				</g>
			</g>
			<g>
				<g>
					<path d="M170.667,290.133c-32.939,0-59.733,26.803-59.733,59.733V384c0,32.93,26.795,59.733,59.733,59.733
			c4.71,0,8.533-3.814,8.533-8.533V298.667C179.2,293.948,175.377,290.133,170.667,290.133z M162.133,425.805
			C142.686,421.845,128,404.608,128,384v-34.133c0-20.608,14.686-37.837,34.133-41.805V425.805z"/>
				</g>
			</g>
			<g id="SVGCleanerId_0">
				<g>
					<path d="M213.333,290.133c0,0-0.017,0-0.026,0.009c-20.053,0-38.647,9.975-49.749,26.675l14.217,9.446
			c6.332-9.523,16.068-15.992,27.025-18.21v117.76c-10.957-2.219-20.693-8.678-27.025-18.202l-14.217,9.446
			c11.102,16.708,29.696,26.675,49.749,26.675c0.009,0,0.026,0,0.026,0c4.719,0,8.533-3.823,8.533-8.533V298.667
			C221.867,293.956,218.044,290.133,213.333,290.133z"/>
				</g>
			</g>
			<g>
				<g>
					<path d="M213.333,290.133c0,0-0.017,0-0.026,0.009c-20.053,0-38.647,9.975-49.749,26.675l14.217,9.446
			c6.332-9.523,16.068-15.992,27.025-18.21v117.76c-10.957-2.219-20.693-8.678-27.025-18.202l-14.217,9.446
			c11.102,16.708,29.696,26.675,49.749,26.675c0.009,0,0.026,0,0.026,0c4.719,0,8.533-3.823,8.533-8.533V298.667
			C221.867,293.956,218.044,290.133,213.333,290.133z"/>
				</g>
			</g>
			<g>
				<g>
					<path d="M256.009,290.142c-0.017,0-0.026,0-0.034,0c-20.053,0-38.647,9.975-49.749,26.675l14.216,9.446
			c6.332-9.523,16.068-15.992,27.025-18.21v117.76c-10.957-2.219-20.693-8.678-27.025-18.202l-14.216,9.446
			c11.102,16.708,29.696,26.675,49.749,26.675c0.008,0,0.026,0,0.034,0c4.71,0,8.525-3.823,8.525-8.533V298.667
			C264.533,293.956,260.719,290.133,256.009,290.142z"/>
				</g>
			</g>
			<g>
				<g>
					<path d="M358.4,290.133c-42.351,0-76.8,34.449-76.8,76.8s34.449,76.8,76.8,76.8s76.8-34.449,76.8-76.8
			S400.751,290.133,358.4,290.133z M358.4,426.667c-32.93,0-59.733-26.803-59.733-59.733c0-32.93,26.803-59.733,59.733-59.733
			c32.93,0,59.733,26.803,59.733,59.733C418.133,399.864,391.33,426.667,358.4,426.667z"/>
				</g>
			</g>
			<g>
				<g>
					<path d="M315.733,366.933H332.8c0-14.114,11.486-25.6,25.6-25.6v-17.067C334.874,324.267,315.733,343.407,315.733,366.933z" />
				</g>
			</g>
			<g>
				<g>
					<path d="M384,366.933c0,14.114-11.486,25.6-25.6,25.6V409.6c23.526,0,42.667-19.14,42.667-42.667H384z" />
				</g>
			</g>
			<g>
				<g>
					<path d="M324.224,263.68l-8.533-85.333c-0.435-4.361-4.105-7.68-8.491-7.68h-42.667c-4.386,0-8.055,3.319-8.491,7.68
			l-8.533,85.333c-0.239,2.406,0.546,4.796,2.167,6.579c1.613,1.792,3.908,2.807,6.323,2.807h59.733c2.406,0,4.71-1.015,6.323-2.807
			C323.678,268.476,324.463,266.078,324.224,263.68z M265.429,256l6.827-68.267h27.213L306.295,256H265.429z"/>
				</g>
			</g>
			<g>
				<g>
					<path d="M409.557,263.68l-8.533-85.333c-0.435-4.361-4.104-7.68-8.491-7.68h-42.667c-4.386,0-8.055,3.319-8.491,7.68
			l-8.533,85.333c-0.239,2.406,0.555,4.796,2.167,6.579c1.613,1.792,3.917,2.807,6.323,2.807h59.733c2.406,0,4.71-1.015,6.323-2.807
			C409.011,268.476,409.796,266.078,409.557,263.68z M350.763,256l6.827-68.267h27.213L391.629,256H350.763z"/>
				</g>
			</g>
			<g>
				<g>
					<rect x="85.333" y="426.667" width="341.333" height="17.067" />
				</g>
			</g>
			<g>
				<g>
					<rect x="85.333" y="221.867" width="341.333" height="17.067" />
				</g>
			</g>
			<g>
				<g>
					<rect x="85.333" y="392.533" width="341.333" height="17.067" />
				</g>
			</g>
			<g>
				<g>
					<path d="M162.133,153.6c-28.237,0-51.2,22.963-51.2,51.2v17.067c0,28.237,22.963,51.2,51.2,51.2c4.71,0,8.533-3.814,8.533-8.533
			v-102.4C170.667,157.423,166.844,153.6,162.133,153.6z M153.6,254.925c-14.703-3.806-25.6-17.186-25.6-33.058V204.8
			c0-15.88,10.897-29.261,25.6-33.058V254.925z"/>
				</g>
			</g>
			<g>
				<g>
					<circle cx="315.733" cy="51.2" r="17.067" />
				</g>
			</g>
			<g>
				<g>
					<rect x="76.8" y="42.667" width="17.067" height="17.067" />
				</g>
			</g>
			<g>
				<g>
					<rect x="418.133" y="42.667" width="17.067" height="17.067" />
				</g>
			</g>
			<g>
				<g>
					<rect x="384" y="42.667" width="17.067" height="17.067" />
				</g>
			</g>
			<g>
				<g>
					<rect x="349.867" y="42.667" width="17.067" height="17.067" />
				</g>
			</g>
			<g>
				<g>
					<path d="M196.267,153.609c-16.034,0-31.343,7.654-40.96,20.48l13.653,10.24c4.676-6.229,11.358-10.633,18.773-12.561v83.14
			c-7.415-1.929-14.097-6.332-18.773-12.561l-13.653,10.24c9.626,12.826,24.934,20.48,40.96,20.48c4.71,0,8.533-3.814,8.533-8.525
			v-102.4C204.8,157.431,200.977,153.609,196.267,153.609z"/>
				</g>
			</g>
			<g>
				<g>
					<path d="M230.4,153.609c-16.034,0-31.343,7.654-40.96,20.48l13.653,10.24c4.676-6.229,11.358-10.633,18.773-12.561v83.14
			c-7.415-1.929-14.097-6.332-18.773-12.561l-13.653,10.24c9.626,12.826,24.934,20.48,40.96,20.48c4.71,0,8.533-3.814,8.533-8.525
			v-102.4C238.933,157.431,235.11,153.609,230.4,153.609z"/>
				</g>
			</g>
			<g>
				<g>
					<rect x="264.533" y="42.667" width="17.067" height="17.067" />
				</g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
		</svg >
	);
};

export default DishwasherIcon;
